class TrackingEvent {
    constructor(eventName) {
        this.callbacks = [];
        this.name = eventName;
    }
    registerCallback(callback) {
        this.callbacks.push(callback);
    }
}
class TrackingEventReactor {
    constructor() {
        this.events = {};
    }
    /**
     * Registeres a new event for later use
     * @param eventName Name of event
     */
    registerEvent(eventName) {
        const event = new TrackingEvent(eventName);
        this.events[eventName] = event;
    }
    /**
     * Dispatches a given event to all listeners
     *
     * @param eventName Name of event
     * @param eventArgs Additional data passed to all listeners
     */
    dispatch(eventName, eventArgs) {
        if (!this.events[eventName]) {
            this.registerEvent(eventName);
        }
        this.events[eventName].callbacks.forEach(callback => {
            callback(eventArgs);
        });
        if (window.laravelDebug) {
            console.log(`%cEVENT: ${eventName} (notified ${this.events[eventName].callbacks.length} listeners)`, 'background: #413daa; color: #fff; padding: 2px 4px; border-radius: 3px;', eventArgs);
        }
    }
    /**
     * Listenes to a given event and runs callback if the event is dispatched
     *
     * @param eventName Name of event
     * @param callback Callback after event is dispatched
     */
    listen(eventName, callback) {
        if (!this.events[eventName]) {
            this.registerEvent(eventName);
        }
        this.events[eventName].registerCallback(callback);
    }
    /**
     * Unregister all event callbacks
     * Stops all listeners from receiving events
     */
    destroy() {
        const eventNames = Object.keys(this.events);
        eventNames.forEach(eventName => {
            this.events[eventName].callbacks = [];
        });
    }
}
export default new TrackingEventReactor();
